import NavLogoMark from '../Navigation/NavLogoMark';
import './SpaceLoader.css';

function SpaceLoader({ message, isExiting }) {
  return (
    <div
      className={`space-loader ${isExiting ? 'space-loader--exiting' : ''}`}
      role="status"
      aria-live="polite"
      aria-label="KF Kevin Fuller, entering site"
    >
      <div className="space-loader__mark" aria-hidden="true">
        <NavLogoMark className="space-loader__logo navLogoSvg" />
      </div>
      <p className="space-loader__text">{message}</p>
    </div>
  );
}

export default SpaceLoader;
